import { envConfigs } from '../../../envConfigs';
import { handleServiceCall } from '../../app/util/fetch-utils';

export const fetchLearnerCanChangeL2 = (organizationId, token) => {
  const egoUri = envConfigs.egoApiHost + `/api/groups/${organizationId}/learnerCanChangeL2`;
  return fetch(egoUri, {
    headers: {
      Authorization: 'Bearer ' + token,
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Accept: 'application/json'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};

export const fetchLearnerConfigs = (organizationId, token) => {
  const egoUri = envConfigs.egoApiHost + `/api/groups/${organizationId}/learnerConfigs`;
  return fetch(egoUri, {
    headers: {
      Authorization: 'Bearer ' + token,
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Accept: 'application/json'
    }
  }).then((response) => {
    return handleServiceCall(response).then((result) => {
      return result.skipPlacementTest;
    });
  });
};



// WEBPACK FOOTER //
// ./src/modules/launchpad/services/ego-api.js